import type { SenderSettingsOverrideOption, SenderSettingsSender } from '@/services/forms/types'
import type { IAddOptionsSection } from '@/services/domain/senderSettings/types'
import type { ConstructorType } from '@/types'

export const CHANNEL_NUMBER_TYPES = ['whatsApp', 'widgets', 'facebook', 'instagram'] as const

export type ChannelNumberType = (typeof CHANNEL_NUMBER_TYPES)[number]

export const isChannelNumberType = (value: string): value is ChannelNumberType =>
  (CHANNEL_NUMBER_TYPES as readonly string[]).includes(value)

export type SenderChannelSubItem = SenderSettingsSender<string | Record<string, unknown>>

export type ChannelSender<K extends ChannelNumberType> = IAddOptionsSection[K]

export interface SenderChannelProvider<T = unknown> {
  fetchSenders(): Promise<T[]>
  mapToSubItem(sender: T): SenderChannelSubItem | null
  getConnectOption?(): SenderSettingsOverrideOption
}

export type ChannelProviderFor<T extends ChannelNumberType> = SenderChannelProvider<ChannelSender<T>>

export type SenderChannelProviderClass<S = unknown> = ConstructorType<SenderChannelProvider<S>> & {
  readonly numberType: ChannelNumberType
}
